/* unplugin-vue-components disabled */import { render } from "./FastMemoryRender.vue?vue&type=template&id=2cfa8c87&scoped=true"
import script from "./FastMemoryRender.vue?vue&type=script&lang=js"
export * from "./FastMemoryRender.vue?vue&type=script&lang=js"

import "./FastMemoryRender.vue?vue&type=style&index=0&id=2cfa8c87&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cfa8c87"]])

export default __exports__